import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Wordmark, Footer } from "@/components/Brand";

export default function BriefUnsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("done"); return; }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/brief/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((r) => r.json())
      .then(() => setState("done"))
      .catch(() => setState("done"));
  }, [params]);
  return (
    <div className="min-h-screen bg-wr-bg flex flex-col" data-testid="brief-unsub-page">
      <header className="px-4 sm:px-8 py-6 border-b border-wr-border"><Wordmark /></header>
      <main className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-md text-center">
          <h1 className="wr-heading text-2xl text-white mb-3" data-testid="brief-unsub-title">
            {state === "loading" ? "Unsubscribing…" : "You're unsubscribed"}
          </h1>
          <p className="text-wr-sub text-sm leading-relaxed mb-6" data-testid="brief-unsub-body">
            {state === "loading"
              ? "One moment."
              : "You won't receive any more Founder Command Brief emails. You can resubscribe anytime from the WarRoom AI site."}
          </p>
          <Link to="/" className="wr-mono uppercase tracking-wider text-xs text-wr-red hover:underline" data-testid="brief-unsub-home">Go to WarRoom AI →</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
